import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LargeLabel from 'base/components/LargeLabel';
import SmallLabel from 'base/components/SmallLabel';
import theme from 'theme/theme';
import UnstyledList from 'base/components/UnstyledList';
import {
  DeskPhoneIcon,
  EmailIcon,
  FaxIcon,
  PersonIcon,
  PhoneIcon,
  SmartphoneIcon,
} from 'base/components/Icon';
import Teaser from 'base/components/Teaser';

class ContactTeaser extends React.Component {
  componentDidMount() {
  }


  render() {
    const {
      entity,
      actions,
    } = this.props;

    return (
      <Teaser actions={actions} item={entity}>

        <Teaser.IconCol>
          <div>
            <PersonIcon color={theme.colors.medium} size="23px" />
          </div>
        </Teaser.IconCol>

        <Teaser.MainCol>
          <LargeLabel isPrimary style={{ marginBottom: '0.5rem' }}>
            {entity.firstName}
            {' '}
            {entity.lastName}
          </LargeLabel>


          <div>
            <UnstyledList>
              {entity.email && (
              <li>
                <SmallLabel>
                  <EmailIcon />
                  {' '}
                  <a href={`mailto:${entity.email}`}>{entity.email}</a>
                </SmallLabel>
              </li>
              )}

              {entity.phone && (
              <li>
                <SmallLabel>
                  <PhoneIcon />
                  {' '}
                  <a href={`tel:${entity.phone}`}>{entity.phone}</a>
                </SmallLabel>
              </li>
              )}

              {entity.mobile && (
              <li>
                <SmallLabel>
                  <SmartphoneIcon />
                  {' '}
                  <a href={`tel:${entity.mobile}`}>{entity.mobile}</a>
                </SmallLabel>
              </li>
              )}

              {entity.fax && (
              <li>
                <SmallLabel>
                  <FaxIcon />
                  {' '}
                  <a href={`tel:${entity.fax}`}>{entity.fax}</a>
                </SmallLabel>
              </li>
              )}

              {entity.switchboard && (
              <li>
                <SmallLabel>
                  <DeskPhoneIcon />
                  {' '}
                  <a href={`tel:${entity.switchboard}`}>{entity.switchboard}</a>
                </SmallLabel>
              </li>
              )}

            </UnstyledList>

          </div>


          <Teaser.MetaWrapper>
            {entity.position && (
            <Teaser.Meta>
              <SmallLabel>{entity.position}</SmallLabel>
            </Teaser.Meta>
            )}
            {entity.division && (
            <Teaser.Meta>
              <SmallLabel>{entity.division}</SmallLabel>
            </Teaser.Meta>
            )}
          </Teaser.MetaWrapper>
        </Teaser.MainCol>

      </Teaser>
    );
  }
}
ContactTeaser.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  entity: PropTypes.objectOf(PropTypes.any).isRequired,
};
ContactTeaser.defaultProps = {
};

// const mapStateToProps = (state, props) => ({
// });
const mapDispatchToProps = {
};

export default connect(
  null,
  mapDispatchToProps,
)(ContactTeaser);
